import {
  RULE_ROOTS,
  RULE_TAG,
} from "components/ContractLanguageSection/constants";
import {
  IRuleAttachment,
  IRuleAttachmentResponse,
  RuleType,
} from "components/ContractLanguageSection/types";

import { api } from ".";

const ruleAttachmentQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    uploadRuleAttachment: builder.mutation<
      IRuleAttachmentResponse,
      { ruleType: RuleType; ruleId: string; file: File }
    >({
      query: ({ ruleType, ruleId, file }) => {
        const formData = new FormData();
        formData.append("file", file);
        return {
          url: `${RULE_ROOTS[ruleType]}/${ruleId}/attachments`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: (_r, _e, { ruleType, ruleId }) => [
        { type: RULE_TAG[ruleType], id: ruleId },
        { type: RULE_TAG[ruleType], id: "LIST" },
      ],
    }),
    deleteRuleAttachment: builder.mutation<
      void,
      { ruleType: RuleType; ruleId: string; attachmentId: string }
    >({
      query: ({ ruleType, ruleId, attachmentId }) => ({
        url: `${RULE_ROOTS[ruleType]}/${ruleId}/attachments/${attachmentId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_r, _e, { ruleType, ruleId }) => [
        { type: RULE_TAG[ruleType], id: ruleId },
        { type: RULE_TAG[ruleType], id: "LIST" },
      ],
    }),
  }),
});

export const {
  useUploadRuleAttachmentMutation,
  useDeleteRuleAttachmentMutation,
} = ruleAttachmentQueries;

export type { IRuleAttachment };
